import type { GofundmeUserJourneysVariant } from '@percent/cause-dashboard/constants/gofundmeUserJourneys'
import gfmLogo from '@percent/cause-dashboard/assets/images/gofundme/banner/gofundme-logo.png'
import supportersImage from '@percent/cause-dashboard/assets/images/gofundme/banner/supporters.webp'
import toolsImage from '@percent/cause-dashboard/assets/images/gofundme/banner/tools.webp'
import goodstackSupportersImage from '@percent/cause-dashboard/assets/images/gofundme/banner/goodstack-supporters.webp'
import goodstackToolsImage from '@percent/cause-dashboard/assets/images/gofundme/banner/goodstack-tools.webp'

const gfmImages: Record<GofundmeUserJourneysVariant, string> = {
  supporters: supportersImage,
  tools: toolsImage,
  supporters_b: supportersImage,
  tools_b: toolsImage,
  goodstack_supporters: goodstackSupportersImage,
  goodstack_tools: goodstackToolsImage
}

export { gfmLogo, gfmImages }
